/**
 * Human-readable label helpers for ER Center enums.
 * Kept in one small module so every page renders the same phrasing.
 */

export const CATEGORY_LABELS = {
  harassment: "Harassment",
  discrimination: "Discrimination",
  retaliation: "Retaliation",
  safety: "Safety",
  wage_and_hour: "Wage & hour",
  policy_question: "Policy question",
  interpersonal_conflict: "Interpersonal conflict",
  other: "Other",
};

export const STATUS_LABELS = {
  new: "New",
  acknowledged: "Acknowledged",
  under_review: "Under Review",
  investigation: "Investigation",
  resolved: "Resolved",
  closed: "Closed",
};

export const PRIORITY_LABELS = {
  low: "Low",
  medium: "Medium",
  high: "High",
};

export function statusPillClass(status) {
  switch (status) {
    case "new":
      return "bg-terracotta-500/15 text-terracotta-600 border-terracotta-500/30";
    case "acknowledged":
      return "bg-sage-300/40 text-forest-800 border-sage-300";
    case "under_review":
    case "investigation":
      return "bg-forest-600/10 text-forest-800 border-forest-600/25";
    case "resolved":
    case "closed":
      return "bg-forest-600 text-cream-100 border-forest-800";
    default:
      return "bg-sage-300/40 text-forest-800 border-sage-300";
  }
}

export function priorityPillClass(pri) {
  switch (pri) {
    case "high":
      return "bg-terracotta-500 text-cream-100 border-terracotta-500";
    case "medium":
      return "bg-terracotta-500/15 text-terracotta-600 border-terracotta-500/30";
    default:
      return "bg-sage-300/40 text-forest-800 border-sage-300";
  }
}
